import { render, staticRenderFns } from "./about04.vue?vue&type=template&id=40e22854&scoped=true&"
import script from "./about04.vue?vue&type=script&lang=js&"
export * from "./about04.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e22854",
  null
  
)

export default component.exports